import { React, useState, useEffect } from 'react'
import LoadingSpinner from '../Components/LoadingSpinner';
import Sidebar from '../Components/Sidebar/Sidebar';
import Topbar from '../Components/Topbar/Topbar';
import { Row, Col, Button } from 'react-bootstrap';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import HolidayModal from './HolidayModal';
import EditModal from './EditModal';
import DeleteModal from './DeleteModal';
import { getHolidayData } from '../Utils/utils';
import CustomSearch from '../Components/CustomSearch';
import moment from 'moment';

const Holiday = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [rows, setRows] = useState([])
  const [rowsId, setRowsID] = useState();
  const [rowsDataName, setRowsDataName] = useState('')
  const [rowsDataType, setRowsDataType] = useState('')
  const [rowsDataDate, setRowsDataDate] = useState();
  const [reloadData, setReloadData] = useState(false);
  const [filterText, setFilterText] = useState('');
  const handleFilterChange = (e) => { setFilterText(e.target.value); };

  const getHolidayDataDetails = async () => {
    setIsLoading(true);
    try {
      const res = await getHolidayData();
      if (res.data && Array.isArray(res.data.data)) {
        const today = new Date();
        today.setHours(0, 0, 0, 0)
        const formattedData = res.data.data.map((item) => {
          const time = new Date(item.date).getTime();
          return ({
            holidayName: item.name,
            holidayDate: item.date,
            holidayType: item.type,
            id: item.id,
            _time: time
          })
        }).sort((a, b) => {
          const aIsPast = a._time < today.getTime();
          const bIsPast = b._time < today.getTime();

          if (aIsPast && !bIsPast) return 1;
          if (!aIsPast && bIsPast) return -1;

          return a._time - b._time;
        });
        setRows(formattedData);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error while fetching holiday data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getHolidayDataDetails()
  }, [])

  useEffect(() => {
    if (reloadData) {
      getHolidayDataDetails();
      setReloadData(false);
    }
  }, [reloadData]);

  const columns = [
    // {
    //   id: 1,
    //   name: "ID",
    //   width: '60px',
    //   sortable: true,
    //   selector: (row) => (
    //     <div style={{
    //       whiteSpace: 'normal',
    //       wordBreak: 'break-word',
    //       overflow: 'hidden',
    //       textOverflow: 'ellipsis',
    //       fontSize: '12px'
    //     }}>
    //       {row.id}
    //     </div>
    //   ),
    // },
    {
      id: 1,
      name: "Holiday Name",
      width: '350px',
      sortable: true,
      selector: row => row.holidayName,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.holidayName}
        </div>
      ),
    },
    {
      id: 2,
      name: "Holiday Date",
      sortable: true,
      width: "320px",
      selector: row => row._time,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {moment(row.holidayDate).format('MM/DD/YYYY')}
        </div>
      ),
    },
    {
      id: 3,
      name: "Holiday Type",
      sortable: true,
      width: "500px",
      selector: row => row.holidayType,
      cell: (row) => (
        <div style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '12px'
        }}>
          {row.holidayType}
        </div>
      ),
    },

    {
      id: 4,
      name: "Action",
      width: "300px",
      cell: (row) => (
        <div className="cell-link">
          <>
            <i className="text-success far fa-edit mr-2" title="Edit"
              onClick={() => {
                setEditModal(true)
                setRowsID(row?.id)
                setRowsDataName(row?.holidayName)
                setRowsDataType(row?.holidayType)
                setRowsDataDate(row?.holidayDate)
              }}>
            </i>
            <i className="text-danger fas fa-trash ml-3" title="Delete"
              onClick={() => {
                setDeleteModal(true)
                setRowsID(row?.id)
                setRowsDataName(row?.holidayName)
                setRowsDataType(row?.holidayType)
                setRowsDataDate(row?.holidayDate)
              }}
            ></i>
          </>
        </div>
      ),
    },
  ];


  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <div className="main-div">
        <div className="blue-back"></div>
        <Row className="w-100 m-auto">
          {/* <Col md={2}>
                <Sidebar />
            </Col> */}
          <Col md={12} className="right-pad">
            <div className="main-text">
              <Topbar />
              <div>
                <div className={'new-card'} style={{ padding: "20px 15px 30px 15px" }}>
                  <div className='top-row'>
                    <div className="row">
                      <div className="col-lg-9">
                        <div className='heading-text'>
                          Holiday
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <CustomSearch filterText={filterText} onFilter={handleFilterChange} />
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="row mb-4 mt-0">
                      <div className="col-md-12">
                        <div className="card m-overflow-h todo-card-list" style={{ border: 'none' }}>
                          <div style={{ position: 'absolute', right: '10px', top: '30px' }}>
                            <Button variant="primary" className='px-3 mx-2'
                              onClick={() => {
                                setAddModal(true)
                              }}>
                              + Add
                            </Button>
                            <Button variant="danger" className='px-3'>
                              Exit
                            </Button>
                          </div>
                          <div className="card-body m-p-0 p-0 mt-5">
                            <DataTableExtensions
                              columns={columns}
                              data={rows.filter((item) => Object.values(item).some((value) => String(value).toLowerCase().includes(filterText.toLowerCase().trim())))}
                              print={false}
                              export={false}
                              filter={false}
                            >
                              <DataTable
                                pagination
                                persistTableHead
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                highlightOnHover
                                customStyles={{
                                  table: {
                                    style: {
                                      border: '1px solid #ccc',
                                    },
                                  },
                                  headCells: {
                                    style: {
                                      backgroundColor: '#8A8A8A',
                                      color: '#ffffff',
                                    },
                                  },
                                }}

                              />
                            </DataTableExtensions>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        {addModal == true ?
          <HolidayModal
            addModal={addModal}
            setAddModal={setAddModal}
            reloadData={setReloadData}
            setReloadData={setReloadData}
          />
          : null}
        {editModal == true ?
          <EditModal
            editModal={editModal}
            setEditModal={setEditModal}
            rowsId={rowsId}
            rowsDataName={rowsDataName}
            rowsDataType={rowsDataType}
            rowsDataDate={rowsDataDate}
            reloadData={setReloadData}
            setReloadData={setReloadData}
          />
          : null}
        {deleteModal == true ?
          <DeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            rowsId={rowsId}
            reloadData={setReloadData}
            setReloadData={setReloadData}
          />
          : null}
      </div>
    </>
  )
}

export default Holiday